// extracted by mini-css-extract-plugin
export default {"container":"aJOn9dqAtghPV4PM3clE","section-realtime":"Ga7gCVYIM86U53WOy4CG","section-status-trend":"t71tWf5_Mcixl4EwKSMT"};